import React, { FC, useMemo } from 'react';
import dropDownOverlayStyles from 'src/shared/DropDownWithSearch/index.module.scss';
import { ISelectedCallOff } from 'src/models/callOffs/types';
import { IBidIdentifier, ILinkedBidIdentifier } from 'src/models/bids/Bids/types';
import BidPickerSearch from '../BidPickerSearch';
import BidPickerList from '../BidPickerList';
import CreateNewBid from '../CreateNewBid';

interface IProps {
  selectedCallOffs: ISelectedCallOff[];
  eventSource: string;
  setIsUpdating: (val: boolean) => void;
  onCloseDropDown: () => void;
  onChange?: () => void;
}

const BidPickerOverlay: FC<IProps> = props => {
  const { onCloseDropDown, selectedCallOffs, setIsUpdating, onChange, eventSource } = props;

  const callOffData = useMemo(() => {
    const linkedBids: ILinkedBidIdentifier[] = [];
    const origins: string[] = [];
    const bids: IBidIdentifier[] = [];

    selectedCallOffs.forEach(callOff => {
      callOff.linkedBid && linkedBids.push(callOff.linkedBid);
      !callOff.bid && origins.push(callOff.id);
      callOff.bid && bids.push(callOff.bid);
    });

    return {
      linkedBids,
      origins,
      bids
    };
  }, [selectedCallOffs]);

  return (
    <div className={dropDownOverlayStyles.menu}>
      <div className={dropDownOverlayStyles.menuInner}>
        <BidPickerSearch />
        <BidPickerList
          origins={callOffData.origins}
          bids={callOffData.bids}
          linkedBids={callOffData.linkedBids}
          setIsUpdating={setIsUpdating}
          onCloseDropDown={onCloseDropDown}
          eventSource={eventSource}
        />
        <CreateNewBid
          origins={callOffData.origins}
          bids={callOffData.bids}
          linkedBids={callOffData.linkedBids}
          setIsUpdating={setIsUpdating}
          onCloseDropDown={onCloseDropDown}
          onChange={onChange}
          eventSource={eventSource}
        />
      </div>
    </div>
  );
};

export default BidPickerOverlay;
